// extracted by mini-css-extract-plugin
module.exports = {"root":"users_root__i6AS9","header":"users_header__2fHZN","description":"users_description__2PWrj","content":"users_content__pUeb8"};